var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 15C17.7034 15 18.375 14.3284 18.375 13.5C18.375 12.6716 17.7034 12 16.875 12C16.0466 12 15.375 12.6716 15.375 13.5C15.375 14.3284 16.0466 15 16.875 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75003 6.375V18C3.75003 18.3978 3.90806 18.7794 4.18937 19.0607C4.47067 19.342 4.8522 19.5 5.25003 19.5H20.25C20.4489 19.5 20.6397 19.421 20.7804 19.2803C20.921 19.1397 21 18.9489 21 18.75V9C21 8.80109 20.921 8.61032 20.7804 8.46967C20.6397 8.32902 20.4489 8.25 20.25 8.25H5.66996C4.65328 8.25 3.78737 7.45942 3.75125 6.44337C3.74206 6.19156 3.78373 5.94047 3.87376 5.70512C3.96379 5.46977 4.10034 5.25497 4.27524 5.07358C4.45014 4.89218 4.65982 4.74789 4.89173 4.64934C5.12364 4.5508 5.37304 4.5 5.62503 4.5H18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.f392e0cd28dc5157ef4c6215642a25a1.svg";
export { ForwardRef as ReactComponent };